import { Box, Stack } from '@mui/material';
import { range } from 'lodash';

export type DotLevelIndicatorProps = {
    level: number;
    maxLevel: number;
    color: 'success' | 'warning' | 'error';
};

export const DotLevelIndicator = ({ level, maxLevel, color }: DotLevelIndicatorProps) => {
    return (
        <Stack direction="row" alignItems="center" gap={0.5}>
            {range(maxLevel).map((dotLevel) => (
                <Box
                    key={`dot-${dotLevel}`}
                    sx={{
                        display: 'inline-block',
                        height: '10px',
                        width: '10px',
                        borderRadius: '50%',
                        bgcolor: (theme) => (dotLevel < level ? theme.palette[color].main : 'lightgray'),
                    }}
                />
            ))}
        </Stack>
    );
};
